module.exports = __webpack_public_path__ + "assets/dropbox-logo.d23e4ec2.svg";